import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "antd/dist/antd.min.css";

import ProtectedLayout from "./components/ProtectedLayout";
import ContentLayout from "./components/ContentLayout";

import DashBoard from "./pages/DashBoard";
import UserManagement from "./pages/UserManagement";
import SoundTracks from "./pages/SoundTracks";
import CashOutRequest from "./pages/CashOutRequest";
import ReportManagement from "./pages/ReportManagement";
import Subscription from "./pages/Subscription";
import TermsAndCondition from "./pages/TermsAndCondition";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Faqs from "./pages/Faqs";
import Notification from "./pages/Notification";
import Login from "./pages/Login";

import PublicRoute from "./components/Routes/PublicRoute";
import ProtectedRoute from "./components/Routes/ProtectedRoute";
import VariablePage from "./pages/VariablePage";
import PostManagement from "./pages/PostManagement";
import ChangePassword from "./pages/ChangePassword";
import DonateHistory from "./pages/DonateHistory";
import { useLocalStorage } from "./hooks/useLocalStorage";
import AdminTracks from "./pages/AdminTracks";
import PostReport from "./pages/PostReport";
import Inbox from "./pages/Inbox";

function App() {
  const user = useLocalStorage();
  return (
    <Router>
      <Routes>
        <Route
          exact
          path={`/login`}
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          exact
          path={`/dashboard`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="0" isSearchBar={false}>
                <ContentLayout>
                  <DashBoard />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/user-management`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="1" isSearchBar={true}>
                <ContentLayout>
                  <UserManagement />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/post-management`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="2" isSearchBar={true}>
                <ContentLayout>
                  <PostManagement />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/reported-users`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="3" isSearchBar={true}>
                <ContentLayout>
                  <ReportManagement />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path={`/reported-posts`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="4" isSearchBar={true}>
                <ContentLayout>
                  <PostReport />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/user-sound-tracks`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="5" isSearchBar={true}>
                <ContentLayout>
                  <SoundTracks />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/upload-sound-tracks`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="6" isSearchBar={true}>
                <ContentLayout>
                  <AdminTracks />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/subscription`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="7" isSearchBar={true}>
                <ContentLayout>
                  <Subscription />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/cash-out-requests`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="8" isSearchBar={true}>
                <ContentLayout>
                  <CashOutRequest />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path={`/donate-history`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="9" isSearchBar={true}>
                <ContentLayout>
                  <DonateHistory />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/coin-setup`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="10" isSearchBar={false}>
                <ContentLayout>
                  <VariablePage />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/notifications`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="11" isSearchBar={false}>
                <ContentLayout>
                  <Notification />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/terms-and-conditions`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="12" isSearchBar={false}>
                <ContentLayout>
                  <TermsAndCondition />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/privacy-policy`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="13" isSearchBar={false}>
                <ContentLayout>
                  <PrivacyPolicy />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/faqs`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="14" isSearchBar={false}>
                <ContentLayout>
                  <Faqs />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path={`/change-password`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="15" isSearchBar={false}>
                <ContentLayout>
                  <ChangePassword />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path={`/inbox`}
          element={
            <ProtectedRoute>
              <ProtectedLayout selectedRoute="16" isSearchBar={false}>
                <ContentLayout>
                  <Inbox />
                </ContentLayout>
              </ProtectedLayout>
            </ProtectedRoute>
          }
        />
        <Route path={`/*`} element={<Navigate to={`/login`} />} />
      </Routes>
    </Router>
  );
}

export default App;
